module.exports = __webpack_public_path__ + "2945bb789c375f309980530ae4e1626a.pdf";